<template>
  <div
      class="toggle d-flex justify-space-between"
      @click="toggle"
      @keydown.space.prevent="toggle"
  >
    <div class="toggle d-flex justify-space-between">
      <slot name="label">
        <span
            v-if="label"
            class="toggle__label"
            :class="{ 'toggle__label--disabled': disabled }"
        >
          {{ label }}
        </span>
      </slot>
    </div>
    <span
        class="toggle__wrapper"
        role="checkbox"
        :aria-checked="value.toString()"
        :aria-disabled="disabled.toString()"
        :tabindex="disabled ? -1 : 0"
        :class="{ 'toggle__wrapper--disabled': disabled }"
    >
      <span
          class="toggle__background"
          :class="{ 'toggle__background--on': value, 'toggle__background--disabled': disabled }"
      />
      <span
          class="toggle__indicator"
          :class="{ 'toggle__indicator--on': value, 'toggle__indicator--disabled': disabled }"
      />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit('input', !this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  user-select: none;
  cursor: pointer;

  &__label {
    font-family: Open Sans;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 140%;
    letter-spacing: 0%;
    vertical-align: middle;
    color: var(--black);

    &--disabled {
      color: #999;
    }
  }

  &__wrapper {
    display: inline-block;
    position: relative;
    cursor: pointer;
    width: 50px;
    height: 30px;
    border-radius: 30px;

    &:focus {
      outline: 0;
    }

    &--disabled {
      cursor: not-allowed;
      pointer-events: none;
    }
  }

  &__background {
    display: inline-block;
    border-radius: 30px;
    height: 100%;
    width: 100%;
    transition: background-color 0.4s ease;
    background-color: var(--another-grey);

    &--on {
      background-color: var(--accent-purple);
    }

    &--disabled {
      background-color: #F0F0F0;
    }

    &--on.toggle__background--disabled {
      background-color: #C8C9E6;
    }
  }

  &__indicator {
    position: absolute;
    height: 22px;
    width: 22px;
    left: 4px;
    bottom: 4px;
    background-color: #ffffff;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    transition: transform 0.4s ease;

    &--on {
      transform: translateX(20px);
    }

    &--disabled {
      background-color: #F8F8F8;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    }
  }
}
</style>